import actionTypes from '@atom/actions/actionTypes';

export const updateInventoryNavigation = data => ({
  type: actionTypes.UPDATE_INVENTORY_NAVIGATION,
  data,
});
